<script lang="ts" setup>
import { PropType } from 'vue';
import { Company } from '@/models/company';

const { company } = defineProps({
  company: {
    type: Object as PropType<Company>,
    required: true,
  },
});
</script>
<template>
  <section class="invoiced-company">
    <div v-text="company.name"></div>
    <div v-text="company.address.name"></div>
    <div v-text="company.address.line_one"></div>
    <div
      v-if="company.address.line_two"
      v-text="company.address.line_two"
    ></div>
    <div>
      <span v-text="company.address.zipcode"></span>&nbsp;
      <span v-text="company.address.city"></span>
    </div>
  </section>
</template>
